export default __webpack_public_path__ + "static/media/hot-gadgets.5aad86ec.png";